import { Policy, User } from "@deathstar/types/northstar";
import { Dialog, DialogContent } from "@material-ui/core";
import { BillingPeriodList } from "./billingPeriodList";
import { Context, IContext } from "./context";
import { DialogHeader } from "./dialogHeader";

export type Config = IContext;

export function BillingPeriodBreakdownDialog({
    open,
    onClose,
    policy,
    isLoading,
    user,
    config,
}: {
    policy: Policy;
    open: boolean;
    onClose: () => void;
    isLoading: boolean;
    user?: User;
    config: IContext;
}): JSX.Element {
    return (
        <Context.Provider value={config}>
            <Dialog
                open={open}
                maxWidth="lg"
                fullWidth
                onClose={onClose}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <DialogContent className="">
                    <div className="flex flex-col gap-8">
                        <DialogHeader policy={policy} />
                        <BillingPeriodList policy={policy} user={user} isLoading={isLoading} onPaymentSuccess={config.onPaymentSuccess} />
                    </div>
                </DialogContent>
            </Dialog>
        </Context.Provider>
    );
}
